import axios from "@/utils/axios";
import { GetRaidsResponse } from "@/api/raids/get-raids.response";
import { GetRaidGroupsResponse } from "@/api/raids/get-raid-groups.response";

export default {
	async fetchRaids(): Promise<GetRaidsResponse> {
		return (await axios().get("/raids/")).data;
	},
	async fetchRaidGroups(): Promise<GetRaidGroupsResponse> {
		return (await axios().get("/raids/groups")).data;
	}
};
